import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function ErrorPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/'); // Redirect ke halaman utama atau halaman lain yang diinginkan
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px', color: 'red' }}>
      <h1>Error!</h1>
      <p style={{ whiteSpace: 'pre-line' }}>  {location.state?.message || 'Terjadi kesalahan, Please ask to administrator!'}</p> {/* Tampilkan pesan error */}
      <button onClick={handleGoBack}>Back To Home</button>
    </div>
  );
}

export default ErrorPage;
